import { render, staticRenderFns } from "./ConfigOptionsSection.vue?vue&type=template&id=70d7142e&scoped=true"
import script from "./ConfigOptionsSection.vue?vue&type=script&lang=js"
export * from "./ConfigOptionsSection.vue?vue&type=script&lang=js"
import style0 from "./ConfigOptionsSection.vue?vue&type=style&index=0&id=70d7142e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d7142e",
  null
  
)

export default component.exports